export const subsidyTracking = {
  // Default documents for "En Cours" (In Progress)
  'subsidyTracking.document.businessPlan': 'Plan d\'affaires / Business plan',
  'subsidyTracking.document.financialStatements': 'États financiers (3 dernières années)',
  'subsidyTracking.document.registrationDocuments': 'Documents d\'enregistrement / KBIS',
  'subsidyTracking.document.projectDescription': 'Description détaillée du projet',
  'subsidyTracking.document.budgetForecasts': 'Prévisions budgétaires',
  
  // Placeholders
  'subsidyTracking.placeholder.addDocument': 'Ajouter un document...',
  'subsidyTracking.placeholder.notes': 'Notes et détails supplémentaires...',
} as const;
